import * as React from "react";
import { Check, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const pricingData = [{
  size: "Fixed-Rate Mortgage",
  price: "6.25%",
  link: "/ContactPage"
}, {
  size: "FHA Loan Program",
  price: "5.75%",
  link: "/ContactPage"
}, {
  size: "VA Home Loan",
  price: "5.50%",
  link: "/ContactPage"
}, {
  size: "Jumbo Loan",
  price: "6.85%",
  link: "/ContactPage"
}];
const includedItems = ["Competitive interest rates", "Flexible down payment options", "Expert mortgage consultation", "Fast pre-approval process", "Dedicated loan officer support"];
const addonItems = ["Rate lock protection", "Property appraisal services", "Homeowners insurance bundles"];
export default function CompareYourOptions() {
  return <section data-section-id="253308" id="compare-your-options" className="bg-background text-foreground pt-12 pb-0">
      <div className="mx-auto max-w-3xl px-4">
        <div className="mb-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground">
              Compare Your Options
            </h2>
            <p className="mt-1 text-base text-muted-foreground">
              Transparent rates and terms tailored to your financial goals.
            </p>
          </div>
        </div>

        <div className="overflow-hidden rounded-md border border-border shadow-lg">
          <Table>
            <TableHeader className="bg-primary">
              <TableRow className="border-none hover:bg-primary">
                <TableHead className="h-12 text-primary-foreground font-default font-semibold uppercase tracking-wider">
                  Loan Type
                </TableHead>
                <TableHead className="h-12 text-primary-foreground font-default font-semibold uppercase tracking-wider">
                  Est. Rate
                </TableHead>
                <TableHead className="h-12 text-right text-primary-foreground font-default font-semibold uppercase tracking-wider">
                  Action
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {pricingData.map((row, i) => <TableRow key={i} data-index={i} className={`border-border transition-colors ${i % 2 === 0 ? 'bg-background' : 'bg-accent/30'} hover:bg-accent`}>
                  <TableCell className="py-4 font-default font-medium text-foreground">
                    {row.size}
                  </TableCell>
                  <TableCell className="font-default text-[20px] font-bold text-white py-4">
                    {row.price}
                  </TableCell>
                  <TableCell className="py-4 text-right">
                    <Button asChild size="sm" variant="secondary" className="font-default font-bold shadow-md hover:scale-105 transition-transform">
                      <Link to={row.link}>Apply</Link>
                    </Button>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 border-t border-border pt-8 sm:grid-cols-2 pb-12">
          <div>
            <h3 className="font-default text-sm font-bold uppercase tracking-widest text-foreground mb-3">
              Standard Benefits
            </h3>
            <ul className="space-y-2">
              {includedItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Check className="h-4 w-4 shrink-0 text-secondary mt-0.5" />
                  <span className="font-default">{item}</span>
                </li>)}
            </ul>
          </div>
          
          <div>
            <h3 className="font-default text-sm font-bold uppercase tracking-widest text-foreground mb-3">
              Optional Enhancements
            </h3>
            <ul className="space-y-2">
              {addonItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Plus className="h-4 w-4 shrink-0 text-secondary mt-0.5" />
                  <span className="font-default">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}